import { reactive } from 'vue';

/** @typedef {import('@/types/nav-menu').NavMenu} NavMenu */
/** @typedef {import('@/types/nav-submenu').NavSubMenu} NavSubMenu */

/**@type NavSubMenu[] */
const submenuBasicSettings = [
  {
    text: 'navigation.settings', //i18n Angabe
    route: '/settings',
  },
  {
    text: 'navigation.terminalSystems',
    route: '/terminal/systems',
  },
];

/**@type NavSubMenu[] */
const submenuMasterdata = [
  {
    text: 'navigation.terminalDeviceTypes',
    route: '/terminal/devicetypes',
  },
  {
    text: 'navigation.terminalGroups',
    route: '/terminal/groups',
  },
  {
    text: 'navigation.terminals',
    route: '/terminal/all',
  },
  {
    text: 'navigation.terminalsCti',
    route: '/terminal/cti',
    isVisible: false,
  },
  {
    text: 'navigation.terminalsDatafox',
    route: '/terminal/datafox',
    isVisible: false,
  },
  {
    text: 'navigation.terminalsDormakaba',
    route: '/terminal/dormakaba',
    isVisible: false,
  },
  {
    text: 'navigation.terminalsIntusCom',
    route: '/terminal/intuscom',
    isVisible: false,
  },
  {
    text: 'navigation.terminalsMulticom',
    route: '/terminal/multicom',
    isVisible: false,
  },
  {
    text: 'navigation.terminalsReinerSct',
    route: '/terminal/reinersct',
    isVisible: false,
  },
  {
    text: 'navigation.terminalsSuprema',
    route: '/terminal/suprema',
    isVisible: false,
  },
  {
    text: 'navigation.badge',
    route: '/badges',
  },
  {
    text: 'navigation.timeFrame',
    route: '/timeframes',
  },
  {
    text: 'navigation.break',
    route: '/breaks',
  },
];

/**@type NavSubMenu[] */
const submenuPermissions = [
  {
    text: 'navigation.usergroups',
    route: '/usergroups',
  },
];

/**@type NavSubMenu[] */
const submenuServices = [];
/**@type NavSubMenu[] */
const submenuClockitgo = [
  {
    icon: 'mdi-account-outline',
    text: 'navigation.appuser',
    route: '/appuser',
  },
  {
    icon: 'mdi-map-marker',
    text: 'navigation.geofencing',
    route: '/geofences',
  },
  {
    icon: 'mdi-account-outline',
    text: 'navigation.appUserGeofences',
    route: '/appuser-geofences',
  },
  {
    icon: 'mdi-map-marker',
    text: 'navigation.pushMessages',
    route: '/pushmessages',
  },
];

/**@type NavSubMenu[] */
const submenuOther = [
  {
    icon: 'mdi-sitemap-outline',
    text: 'navigation.workflow',
    route: '/workflows',
  },
  {
    icon: 'mdi-file-key-outline',
    text: 'navigation.accessLog',
    route: '/accesslog',
  },
  {
    icon: 'mdi-note-text-outline',
    text: 'navigation.log',
    route: '/log',
  },
];

/**@type {NavMenu[]} */
const menu = reactive([
  {
    icon: 'mdi-home-outline',
    text: 'navigation.home',
    route: '/home',
  },
  {
    icon: 'mdi-clipboard-text-clock-outline',
    text: 'navigation.bookings',
    route: '/bookings',
  },
  {
    icon: 'mdi-account-multiple-outline',
    text: 'navigation.employees',
    route: '/employees',
  },
  {
    icon: 'mdi-cog-outline',
    text: 'navigation.basicSettings', //i18n Angabe
    submenu: submenuBasicSettings,
  },
  {
    icon: 'mdi-database-outline',
    text: 'navigation.masterdata',
    submenu: submenuMasterdata,
  },
  {
    icon: 'mdi-badge-account-outline',
    text: 'navigation.permissions',
    submenu: submenuPermissions,
  },

  {
    icon: 'mdi-application-brackets-outline',
    text: 'navigation.services',
    submenu: submenuServices,
  },
  {
    icon: 'mdi-cellphone-cog',
    text: 'navigation.clockitgo',
    submenu: submenuClockitgo,
  },
  {
    icon: 'mdi-book-outline',
    text: 'navigation.other',
    submenu: submenuOther,
  },
]);

export default menu;
